var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8MoreInfo100(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "33.3667px",
    heigh: "50px",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M792 928 c-19 -19 -14 -46 10 -59 18 -10 24 -8 40 11 31 38 -15 83 -50 48z",
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 889 c-85 -25 -135 -128 -115 -237 6 -36 6 -63 -1 -81 -8 -21 -6 -34 6 -57 59 -110 68 -135 65 -176 l-3 -43 -82 -40 c-120 -59 -173 -117 -173 -190 l0 -25 380 0 380 0 0 25 c0 73 -54 132 -173 190 -81 39 -82 41 -85 80 -3 38 15 86 65 179 12 22 13 37 6 55 -5 14 -6 37 -2 51 4 14 7 50 8 80 1 67 -22 119 -64 141 -16 8 -46 25 -65 37 -37 23 -90 27 -147 11z m122 -41 c14 -6 25 -15 25 -20 0 -4 7 -8 16 -8 8 0 29 -13 45 -29 24 -25 29 -38 29 -78 0 -26 -5 -66 -10 -88 -6 -26 -5 -44 2 -52 12 -15 -4 -63 -22 -63 -5 0 -10 -10 -10 -22 0 -13 -9 -38 -20 -56 -13 -22 -20 -50 -20 -85 0 -66 22 -89 132 -141 75 -36 118 -75 118 -110 0 -14 -35 -16 -330 -16 -295 0 -330 2 -330 16 0 35 43 74 125 113 46 22 93 50 104 62 29 31 29 115 1 161 -11 18 -20 43 -20 56 0 12 -5 22 -10 22 -18 0 -34 48 -22 63 9 10 9 29 1 72 -13 69 -5 125 23 161 38 48 117 68 173 42z",
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760 800 c0 -13 7 -20 20 -20 19 0 20 -7 20 -100 0 -93 -1 -100 -20 -100 -13 0 -20 -7 -20 -20 0 -18 7 -20 60 -20 53 0 60 2 60 20 0 13 -7 20 -20 20 -19 0 -20 7 -20 120 l0 120 -40 0 c-33 0 -40 -3 -40 -20z",
    transform: "translate(0.000000,100.000000) scale(0.100000,-0.100000)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8MoreInfo100);
export default __webpack_public_path__ + "static/media/icons8-more-info-100.83c0cb3139b9e7ecf35e92bb14378853.svg";
export { ForwardRef as ReactComponent };